// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-expand[data-v-6a497ed4] {\n  width: 96%;\n  margin: auto;\n}\n.expand[data-v-6a497ed4] {\n  margin: 0 20px;\n}", ""]);
// Exports
module.exports = exports;
